// extracted by mini-css-extract-plugin
module.exports = {"PartViewerFeedbackContainer":"feedback_PartViewerFeedbackContainer__UW8sd"};